export enum DashboardEnum {
  COVID_MEASURES_INITIAL_DATE = '2021-12-25',
  COVID_MEASURES_FINAL_DATE = '2022-01-15',
}
